import { useTranslation } from 'react-i18next';
import { applyChromeLocale, directionFor } from './config';
import type { Locale } from '@/lib/api/types';

/** Current chrome locale + a setter that flips i18next and <html lang/dir>. */
export function useLocale(): { locale: Locale; isRtl: boolean; setLocale: (l: Locale) => void } {
  const { i18n } = useTranslation();
  const locale = (i18n.language === 'ar' ? 'ar' : 'en') as Locale;
  return {
    locale,
    isRtl: locale === 'ar',
    setLocale: (l: Locale) => applyChromeLocale(l),
  };
}

/**
 * The chrome's writing direction, for Radix primitives and portalled surfaces.
 *
 * Subscribes to the language (rather than reading `document.documentElement.dir`), so the
 * header's EN/AR toggle turns a primitive round on the click, not on the next re-render.
 */
export function useChromeDirection(): 'rtl' | 'ltr' {
  const { i18n } = useTranslation();
  return directionFor(i18n.language);
}
